import type { ButtonHTMLAttributes, ReactNode } from 'react';

type LovemoButtonVariant = 'primary' | 'accent' | 'outline' | 'ghost';
type LovemoButtonSize = 'sm' | 'md' | 'lg';

interface LovemoButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: LovemoButtonVariant;
  size?: LovemoButtonSize;
}

const sizeMap: Record<LovemoButtonSize, string> = {
  sm: 'px-4 py-2 text-sm gap-1.5',
  md: 'px-5 py-2.5 text-sm gap-2',
  lg: 'px-7 py-3.5 text-base gap-2.5',
};

const variantMap: Record<LovemoButtonVariant, string> = {
  primary: 'bg-primary-500 text-background-50 hover:bg-primary-600 dark:text-foreground-950',
  accent: 'bg-accent-500 text-background-50 hover:bg-accent-600 dark:text-foreground-950',
  outline:
    'border border-foreground-300/50 text-foreground-900 hover:bg-background-100 dark:border-background-400/60 dark:text-foreground-900',
  ghost: 'text-foreground-800 hover:bg-background-100',
};

export default function LovemoButton({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  ...rest
}: LovemoButtonProps) {
  return (
    <button
      className={`inline-flex cursor-pointer items-center justify-center whitespace-nowrap rounded-full font-label font-semibold transition-all duration-200 hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400/70 ${sizeMap[size]} ${variantMap[variant]} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}